/* eslint-disable no-shadow */
import actions from './actions';
import mutations from './mutations';
import { renderContextValue } from './helpers';
import { isContextKeyGroupLocked } from '../../../lib/util';

const USERROLE_KEY = 'id_userRole';

const state = {
  context: {},
  keys: [],
  previousContext: {},
  previousKeys: []
};

const getters = {
  items: (state) =>
    state.keys.map((key) => {
      return state.context[key];
    }),
  previousItems: (state) =>
    state.previousKeys.map((key) => {
      return state.previousContext[key];
    }),
  values: (state, getters, rootState, rootGetters) => {
    const obj = {};
    const userRole = rootGetters['authorisation/role'];
    state.keys.forEach((key) => {
      const item = state.context[key];
      const itemKey = item.key.toLowerCase();
      const isGroupLocked = isContextKeyGroupLocked(item, rootState.client);
      let itemValue = null;

      if (item.tags && item.tags.find((e) => e.trim().toLowerCase() === 'variable')) {
        // Process variables as booleans, "no" === false, "false" === false
        const falsyStrings = ['false', 'no', ''];

        if (item.value) {
          const lct = item.value.trim().toLowerCase();
          itemValue = falsyStrings.find((e) => e === lct) ? null : item.value;
        } else {
          itemValue = null;
        }
        obj[itemKey] = itemValue;

        return;
      }
      if (item.value) {
        itemValue = renderContextValue(
          item,
          userRole,
          rootGetters['authorisation/isAdminDraftView']
        );
      } else if (item.placeholder) {
        const phtml = item.placeholder;
        if (userRole === 1 || rootGetters['authorisation/isAdminDraftView']) {
          itemValue = `<span>${phtml}</span>`;
        } else {
          itemValue = `<span class="placeholder" style="cursor:pointer;" data-key="${itemKey}">${phtml}</span>`;
        }
      } else if (userRole === 1 || rootGetters['authorisation/isAdminDraftView']) {
        itemValue = `<span>Missing value for context key ${itemKey}</span>`;
      } else {
        itemValue = `<span class="placeholder" style="cursor:pointer;" data-key="${itemKey}">Missing value for context key ${itemKey}</span>`;
      }

      // if the key is group locked and not in isAdminDraftView, add tooltip
      if (!rootGetters['authorisation/isAdminDraftView'] && isGroupLocked) {
        if (itemValue && itemValue.indexOf('<span') > -1) {
          itemValue = itemValue.replace(
            '<span',
            '<span title="This value is managed by your group administrator"'
          );
        } else {
          itemValue = `<span title='This value is managed by your group administrator'>${itemValue}</span>`;
        }

        itemValue = itemValue.replace(/class=".*placeholder.*"/g, (match) => {
          return match.replace(/\s*placeholder\s*/g, '');
        });
        itemValue = itemValue.replace(/class=".*validContext.*"/g, (match) => {
          return match.replace(/\s*validContext\s*/g, '');
        });
      }

      obj[itemKey] = itemValue;
    });
    return obj;
  },

  viewOnlyContextKeyValues(state) {
    const obj = {};
    const userRole = parseInt(localStorage.getItem(USERROLE_KEY), 10);
    state.keys.forEach((key) => {
      const item = state.context[key];
      const itemKey = item.key.toLowerCase();
      let itemValue = null;

      if (item.tags && item.tags.find((e) => e.trim().toLowerCase() === 'variable')) {
        // Process variables as booleans, "no" === false, "false" === false
        const falsyStrings = ['false', 'no', ''];

        if (item.value) {
          const lct = item.value.trim().toLowerCase();
          itemValue = falsyStrings.find((e) => e === lct) ? null : item.value;
        } else {
          itemValue = null;
        }
        obj[itemKey] = itemValue;

        return;
      }
      if (item.value) {
        itemValue = renderContextValue(item, userRole, false, true);
      } else if (item.placeholder) {
        itemValue = `<span class="tooltip placeholder">${item.placeholder}<span class="tooltip-text">This value can't be edited.</span></span>`;
      } else {
        itemValue = `<span class="tooltip placeholder">Missing value for context key ${itemKey}<span class="tooltip-text">This value can't be edited.</span></span>`;
      }
      obj[itemKey] = itemValue;
    });
    return obj;
  },

  previousValues: (state, getters, rootState, rootGetters) => {
    const obj = {};
    const userRole = parseInt(localStorage.getItem(USERROLE_KEY), 10);
    state.previousKeys.forEach((key) => {
      const item = state.previousContext[key];
      const itemKey = item.key.toLowerCase();
      let itemValue = null;

      if (item.tags && item.tags.find((e) => e.trim().toLowerCase() === 'variable')) {
        // Process variables as booleans, "no" === false, "false" === false
        const falsyStrings = ['false', 'no', ''];
        if (item.value) {
          const lct = item.value.trim().toLowerCase();
          itemValue = falsyStrings.find((e) => e === lct) ? null : item.value;
        } else {
          itemValue = null;
        }
        obj[itemKey] = itemValue;

        return;
      }
      if (item.value) {
        itemValue = renderContextValue(
          item,
          userRole,
          rootGetters['authorisation/isAdminDraftView'],
          !!rootGetters['data/getPageCommitOID']
        );
      } else if (item.placeholder) {
        const phtml = item.placeholder;
        if (userRole === 1 || rootGetters['authorisation/isAdminDraftView']) {
          itemValue = `<span>${phtml}</span>`;
        } else {
          itemValue = `<span class="tooltip placeholder">${phtml}<span class="tooltip-text">This value can't be edited.</span></span>`;
        }
      } else if (userRole === 1 || rootGetters['authorisation/isAdminDraftView']) {
        itemValue = `<span>Missing value for context key ${itemKey}</span>`;
      } else {
        itemValue = `<span class="tooltip placeholder">Missing value for context key ${itemKey}<span class="tooltip-text">This value can't be edited.</span></span>`;
      }

      obj[itemKey] = itemValue;
    });
    return obj;
  },

  getContextItem: (state) => (key) => state.context[key]
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
